import React, { useEffect, useState } from "react";
import "./CustomAddEditAddress.css";
import Header from "../../Layout/Header/Header";
import Icons from "../../../../Config/Images";
import Footer from "../../Layout/Footer/Footer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  addAddressApi,
  getUserAddressTypeAPI,
  updateAddressApi,
} from "../../../../Store/Action/addressAction";
import { toast } from "react-toastify";
import { getCityStateDistrictByPinCode } from "../../../../Store/Action/onboardingAction";

const CustomAddEditAddress = ({ headerText, buttonText }) => {
  // Destructure the type-address parameter from useParams
  //   const { "type-address": typeAddress } = useParams();

  // Set header and button text based on URL param
  //   const headerText =
  //     typeAddress === "add-address" ? "Add Address" : "Edit Address";
  //   const buttonText = typeAddress === "add-address" ? "Save" : "Update";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [userAddressTypeData, setUserAddressTypeData] = useState([]);

  const shippingAddressType = userAddressTypeData?.find(
    (e) => e?.address_type_name?.toLowerCase() === "shipping"
  );
  const billingAddressType = userAddressTypeData?.find(
    (e) => e?.address_type_name?.toLowerCase() === "billing"
  );
  const addressType = location.state.addressType || {};

  const addressData = location.state.addressData || {};
  const isCartScreenVisit = location.state.isCartScreenVisit || false;
  // State to manage form inputs
  const [formData, setFormData] = useState({
    name: addressData.user_first_name || "",
    mobileNumber: addressData.user_mobile_number || "",
    address: addressData.user_address_1 || "",
    landmark: addressData.user_address_2 || "",
    pincode: addressData.zip_code || "",
    city: addressData.city || "",
    state: addressData.state || "",
  });

  useEffect(() => {
    dispatch(
      getUserAddressTypeAPI({}, (result) => {
        setUserAddressTypeData(result);
      })
    );
  }, [dispatch]);
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   // setFormData({ ...formData, [name]: value });
  //   if (name === "mobileNumber" || name == "pincode") {
  //     // Remove any non-numeric characters
  //     const numericValue = value.replace(/\D/g, ""); // Keep only digits
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: numericValue === "" ? null : numericValue,
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value === "" ? null : value,
  //     }));
  //   }

  //   // Clear the specific error for the field being edited
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [name]: "",
  //   }));
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // Restrict commas in address
    if (name === "address") {
      updatedValue = value.replace(/,/g, ""); // Remove all commas
    }

    // Remove non-numeric characters for mobileNumber and pincode
    if (name === "mobileNumber" || name === "pincode") {
      updatedValue = updatedValue.replace(/\D/g, ""); // Keep only digits
      setFormData((prev) => ({
        ...prev,
        [name]: updatedValue === "" ? null : updatedValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: updatedValue === "" ? null : updatedValue,
      }));
    }

    // Clear specific field error
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const [errors, setErrors] = useState({});
  const validationAddress = () => {
    let isValid = true;
    const newErrors = {};

    const requiredFields = [
      "name",
      "mobileNumber",
      "address",
      "landmark",
      "pincode",
      // "city",
      // "state",
    ];

    // Check for missing required fields
    requiredFields.forEach((field) => {
      const value = formData[field]?.toString()?.trim(); // Ensures values like 0 are valid, trims extra spaces

      if (!value) {
        newErrors[field] = `${field
          .replace(/([A-Z])/g, " $1")
          .toLowerCase()} is required`; // Makes 'firstName' to 'First Name' for readability
        isValid = false;
      }
    });
    setErrors(newErrors);
    return isValid;
  };
  const handleSaveorUpdate = () => {
    if (validationAddress()) {
      let requestData;

      if (
        headerText.toLowerCase() === "edit address" &&
        buttonText.toLowerCase() === "update"
      ) {
        //update API call
        requestData = {
          user_address_id: addressData.user_address_id,
          user_first_name: formData.name,
          user_last_name: formData.name,
          user_email: addressData.user_email,
          address_type_id:
            addressType == "billing"
              ? billingAddressType?.address_type_id
              : shippingAddressType?.address_type_id,
          // company_name: null,
          user_mobile_number: formData.mobileNumber,
          // user_alternate_mobile_number: "5665767679",
          user_address_1: formData.address,
          user_address_2: formData.landmark,
          city: formData.city,
          state: formData.state,
          zip_code: formData.pincode,
          country: "test country",
          delivery_instructions: "test delivery",
        };
        dispatch(
          addAddressApi(requestData, (result) => {
            if (result?.data?.status) {
              toast.success(result.data.message.message);
              isCartScreenVisit
                ? navigate("/cart")
                : navigate("/my-account/my-address");
            }
          })
        );
      } else {
        //Add Api call
        requestData = {
          [addressType === "billing"
            ? "billing_first_name"
            : "user_first_name"]: formData.name,
          [addressType === "billing" ? "billing_last_name" : "user_last_name"]:
            formData.name,
          // user_email: "info@gmail.com",
          [addressType === "billing"
            ? "billing_address_type_id"
            : "address_type_id"]: addressType == "billing" ? 2 : 1,
          // company_name: null,
          [addressType === "billing"
            ? "billing_mobile_number"
            : "user_mobile_number"]: formData.mobileNumber,
          // user_alternate_mobile_number: "5665767679",
          [addressType === "billing" ? "billing_address_1" : "user_address_1"]:
            formData.address,
          [addressType === "billing" ? "billing_address_2" : "user_address_2"]:
            formData.landmark,
          [addressType === "billing" ? "billing_city" : "city"]: formData.city,
          [addressType === "billing" ? "billing_state" : "state"]:
            formData.state,
          [addressType === "billing" ? "billing_zip_code" : "zip_code"]:
            formData.pincode,
          [addressType === "billing" ? "billing_country" : "country"]:
            "test country",
          [addressType === "billing"
            ? "billing_delivery_instructions"
            : "delivery_instructions"]: "test delivery",
        };

        dispatch(
          addAddressApi(requestData, (result) => {
            if (result?.status) {
              toast.success(result?.data?.message?.message);
              navigate("/my-account/my-address");
            } else {
              // toast.error(result?.error?.message)
              toast.error("error set error message from API response");
            }
          })
        );
      }
    }
  };
  const handleMouseOutForPinCode = () => {
    const pinCode = formData.pincode;
    dispatch(
      getCityStateDistrictByPinCode(pinCode, (result) => {
        if (result?.status) {
          // setFormData({
          // ...formData,
          // state: result?.data?.user_state,
          // city: result?.data?.user_city,
          // district: result?.data?.user_district,
          // });
          // Create a new object with only available fields
          const updatedFields = {};

          if (result?.data?.user_state) {
            updatedFields.state = result?.data?.user_state;
          }
          if (result?.data?.user_city) {
            updatedFields.city = result?.data?.user_city;
          }
          if (result?.data?.user_district) {
            updatedFields.district = result?.data?.user_district;
          }

          // Update state only if there are changes
          if (Object.keys(updatedFields).length > 0) {
            setFormData((prevData) => ({
              ...prevData,
              ...updatedFields,
            }));
          }
        }
      })
    );
  };
  return (
    <>
      <Header />
      <div className="add-edit-address-main-div">
        <div className="account-header">
          <p className="ac-header-para">{headerText}</p>
        </div>

        <div className="divider" />

        <div className="user-details-div">
          <div className="user-detail-section">
            <p>Name</p>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter your name "
            />
            {errors.name && (
              <div className="error-class-address">{errors.name}</div>
            )}
          </div>
          <div className="user-detail-section">
            <p>Mobile Number</p>
            <input
              type="text"
              name="mobileNumber"
              value={formData.mobileNumber || ""}
              onChange={handleInputChange}
              placeholder="Enter Mobile Number"
              maxLength={10}
            />
            {errors.mobileNumber && (
              <div className="error-class-address">{errors.mobileNumber}</div>
            )}
          </div>
          <div className="user-detail-section">
            <p>Address (Building, Street, Area)</p>
            <div className="input-with-icon">
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Enter Address"
              />

              {/* <img className="edit-icon-img" src={Icons.edit_icon} alt="Edit" /> */}
            </div>
            {errors.address && (
              <div className="error-class-address">{errors.address}</div>
            )}
          </div>
          <div className="user-detail-section">
            <p>Landmark</p>
            <div className="input-with-icon">
              <input
                type="text"
                name="landmark"
                value={formData.landmark}
                onChange={handleInputChange}
                placeholder="Enter Landmark"
              />
              {/* <img className="edit-icon-img" src={Icons.edit_icon} alt="Edit" /> */}
            </div>
            {errors.landmark && (
              <div className="error-class-address">{errors.landmark}</div>
            )}
          </div>

          <div className="user-detail-section">
            <p>Pincode</p>
            <input
              maxLength={6}
              type="text"
              name="pincode"
              value={formData.pincode || ""}
              onChange={handleInputChange}
              onBlur={(e) => {
                handleMouseOutForPinCode(e);
                // handleFormFieldChange(e);
              }}
              placeholder="Enter Pincode"
            />
            {errors.pincode && (
              <div className="error-class-address">{errors.pincode}</div>
            )}
          </div>
          <div className="user-detail-section">
            <p>City</p>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              placeholder="Enter City"
            />
            {errors.city && (
              <div className="error-class-address">{errors.city}</div>
            )}
          </div>
          <div className="user-detail-section">
            <p>State</p>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleInputChange}
              placeholder="Enter State"
            />
            {errors.state && (
              <div className="error-class-address">{errors.state}</div>
            )}
          </div>
        </div>

        <div className="save-update-btn">
          <button onClick={handleSaveorUpdate}>{buttonText}</button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CustomAddEditAddress;
